export default [ {
    n: "Afghanistan (‫افغانستان‬‎)",
    i: "af"
}, {
    n: "Åland Islands (Åland)",
    i: "ax"
}, {
    n: "Albania (Shqipëri)",
    i: "al"
}, {
    n: "Algeria (‫الجزائر‬‎)",
    i: "dz"
}, {
    n: "American Samoa",
    i: "as"
}, {
    n: "Andorra",
    i: "ad"
}, {
    n: "Angola",
    i: "ao"
}, {
    n: "Anguilla",
    i: "ai"
}, {
    n: "Antigua and Barbuda",
    i: "ag"
}, {
    n: "Argentina",
    i: "ar"
}, {
    n: "Armenia (Հայաստան)",
    i: "am"
}, {
    n: "Aruba",
    i: "aw"
}, {
    n: "Australia",
    i: "au"
}, {
    n: "Austria (Österreich)",
    i: "at"
}, {
    n: "Azerbaijan (Azərbaycan)",
    i: "az"
}, {
    n: "Bahamas",
    i: "bs"
}, {
    n: "Bahrain (‫البحرين‬‎)",
    i: "bh"
}, {
    n: "Bangladesh (বাংলাদেশ)",
    i: "bd"
}, {
    n: "Barbados",
    i: "bb"
}, {
    n: "Belarus (Беларусь)",
    i: "by"
}, {
    n: "Belgium (België)",
    i: "be"
}, {
    n: "Belize",
    i: "bz"
}, {
    n: "Benin (Bénin)",
    i: "bj"
}, {
    n: "Bermuda",
    i: "bm"
}, {
    n: "Bhutan (འབྲུག)",
    i: "bt"
}, {
    n: "Bolivia",
    i: "bo"
}, {
    n: "Bosnia and Herzegovina (Босна и Херцеговина)",
    i: "ba"
}, {
    n: "Botswana",
    i: "bw"
}, {
    n: "Brazil (Brasil)",
    i: "br"
}, {
    n: "British Indian Ocean Territory",
    i: "io"
}, {
    n: "British Virgin Islands",
    i: "vg"
}, {
    n: "Brunei",
    i: "bn"
}, {
    n: "Bulgaria (България)",
    i: "bg"
}, {
    n: "Burkina Faso",
    i: "bf"
}, {
    n: "Burundi (Uburundi)",
    i: "bi"
}, {
    n: "Cambodia (កម្ពុជា)",
    i: "kh"
}, {
    n: "Cameroon (Cameroun)",
    i: "cm"
}, {
    n: "Canada",
    i: "ca"
}, {
    n: "Cape Verde (Kabu Verdi)",
    i: "cv"
}, {
    n: "Caribbean Netherlands",
    i: "bq"
}, {
    n: "Cayman Islands",
    i: "ky"
}, {
    n: "Central African Republic (République Centrafricaine)",
    i: "cf"
}, {
    n: "Chad (Tchad)",
    i: "td"
}, {
    n: "Chile",
    i: "cl"
}, {
    n: "China (中国)",
    i: "cn"
}, {
    n: "Christmas Island",
    i: "cx"
}, {
    n: "Cocos (Keeling) Islands (Kepulauan Cocos (Keeling))",
    i: "cc"
}, {
    n: "Colombia",
    i: "co"
}, {
    n: "Comoros (‫جزر القمر‬‎)",
    i: "km"
}, {
    n: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    i: "cd"
}, {
    n: "Congo (Republic) (Congo-Brazzaville)",
    i: "cg"
}, {
    n: "Cook Islands",
    i: "ck"
}, {
    n: "Costa Rica",
    i: "cr"
}, {
    n: "Côte d’Ivoire",
    i: "ci"
}, {
    n: "Croatia (Hrvatska)",
    i: "hr"
}, {
    n: "Cuba",
    i: "cu"
}, {
    n: "Curaçao",
    i: "cw"
}, {
    n: "Cyprus (Κύπρος)",
    i: "cy"
}, {
    n: "Czech Republic (Česká republika)",
    i: "cz"
}, {
    n: "Denmark (Danmark)",
    i: "dk"
}, {
    n: "Djibouti",
    i: "dj"
}, {
    n: "Dominica",
    i: "dm"
}, {
    n: "Dominican Republic (República Dominicana)",
    i: "do"
}, {
    n: "Ecuador",
    i: "ec"
}, {
    n: "Egypt (‫مصر‬‎)",
    i: "eg"
}, {
    n: "El Salvador",
    i: "sv"
}, {
    n: "Equatorial Guinea (Guinea Ecuatorial)",
    i: "gq"
}, {
    n: "Eritrea",
    i: "er"
}, {
    n: "Estonia (Eesti)",
    i: "ee"
}, {
    n: "Ethiopia",
    i: "et"
}, {
    n: "Falkland Islands (Islas Malvinas)",
    i: "fk"
}, {
    n: "Faroe Islands (Føroyar)",
    i: "fo"
}, {
    n: "Fiji",
    i: "fj"
}, {
    n: "Finland (Suomi)",
    i: "fi"
}, {
    n: "France",
    i: "fr"
}, {
    n: "French Guiana (Guyane française)",
    i: "gf"
}, {
    n: "French Polynesia (Polynésie française)",
    i: "pf"
}, {
    n: "Gabon",
    i: "ga"
}, {
    n: "Gambia",
    i: "gm"
}, {
    n: "Georgia (საქართველო)",
    i: "ge"
}, {
    n: "Germany (Deutschland)",
    i: "de"
}, {
    n: "Ghana (Gaana)",
    i: "gh"
}, {
    n: "Gibraltar",
    i: "gi"
}, {
    n: "Greece (Ελλάδα)",
    i: "gr"
}, {
    n: "Greenland (Kalaallit Nunaat)",
    i: "gl"
}, {
    n: "Grenada",
    i: "gd"
}, {
    n: "Guadeloupe",
    i: "gp"
}, {
    n: "Guam",
    i: "gu"
}, {
    n: "Guatemala",
    i: "gt"
}, {
    n: "Guernsey",
    i: "gg"
}, {
    n: "Guinea (Guinée)",
    i: "gn"
}, {
    n: "Guinea-Bissau (Guiné Bissau)",
    i: "gw"
}, {
    n: "Guyana",
    i: "gy"
}, {
    n: "Haiti",
    i: "ht"
}, {
    n: "Honduras",
    i: "hn"
}, {
    n: "Hong Kong (香港)",
    i: "hk"
}, {
    n: "Hungary (Magyarország)",
    i: "hu"
}, {
    n: "Iceland (Ísland)",
    i: "is"
}, {
    n: "India (भारत)",
    i: "in"
}, {
    n: "Indonesia",
    i: "id"
}, {
    n: "Iran (‫ایران‬‎)",
    i: "ir"
}, {
    n: "Iraq (‫العراق‬‎)",
    i: "iq"
}, {
    n: "Ireland",
    i: "ie"
}, {
    n: "Isle of Man",
    i: "im"
}, {
    n: "Israel (‫ישראל‬‎)",
    i: "il"
}, {
    n: "Italy (Italia)",
    i: "it"
}, {
    n: "Jamaica",
    i: "jm"
}, {
    n: "Japan (日本)",
    i: "jp"
}, {
    n: "Jersey",
    i: "je"
}, {
    n: "Jordan (‫الأردن‬‎)",
    i: "jo"
}, {
    n: "Kazakhstan (Казахстан)",
    i: "kz"
}, {
    n: "Kenya",
    i: "ke"
}, {
    n: "Kiribati",
    i: "ki"
}, {
    n: "Kosovo (Kosovë)",
    i: "xk"
}, {
    n: "Kuwait (‫الكويت‬‎)",
    i: "kw"
}, {
    n: "Kyrgyzstan (Кыргызстан)",
    i: "kg"
}, {
    n: "Laos (ລາວ)",
    i: "la"
}, {
    n: "Latvia (Latvija)",
    i: "lv"
}, {
    n: "Lebanon (‫لبنان‬‎)",
    i: "lb"
}, {
    n: "Lesotho",
    i: "ls"
}, {
    n: "Liberia",
    i: "lr"
}, {
    n: "Libya (‫ليبيا‬‎)",
    i: "ly"
}, {
    n: "Liechtenstein",
    i: "li"
}, {
    n: "Lithuania (Lietuva)",
    i: "lt"
}, {
    n: "Luxembourg",
    i: "lu"
}, {
    n: "Macau (澳門)",
    i: "mo"
}, {
    n: "Macedonia (FYROM) (Македонија)",
    i: "mk"
}, {
    n: "Madagascar (Madagasikara)",
    i: "mg"
}, {
    n: "Malawi",
    i: "mw"
}, {
    n: "Malaysia",
    i: "my"
}, {
    n: "Maldives",
    i: "mv"
}, {
    n: "Mali",
    i: "ml"
}, {
    n: "Malta",
    i: "mt"
}, {
    n: "Marshall Islands",
    i: "mh"
}, {
    n: "Martinique",
    i: "mq"
}, {
    n: "Mauritania (‫موريتانيا‬‎)",
    i: "mr"
}, {
    n: "Mauritius (Moris)",
    i: "mu"
}, {
    n: "Mayotte",
    i: "yt"
}, {
    n: "Mexico (México)",
    i: "mx"
}, {
    n: "Micronesia",
    i: "fm"
}, {
    n: "Moldova (Republica Moldova)",
    i: "md"
}, {
    n: "Monaco",
    i: "mc"
}, {
    n: "Mongolia (Монгол)",
    i: "mn"
}, {
    n: "Montenegro (Crna Gora)",
    i: "me"
}, {
    n: "Montserrat",
    i: "ms"
}, {
    n: "Morocco (‫المغرب‬‎)",
    i: "ma"
}, {
    n: "Mozambique (Moçambique)",
    i: "mz"
}, {
    n: "Myanmar (Burma) (မြန်မာ)",
    i: "mm"
}, {
    n: "Namibia (Namibië)",
    i: "na"
}, {
    n: "Nauru",
    i: "nr"
}, {
    n: "Nepal (नेपाल)",
    i: "np"
}, {
    n: "Netherlands (Nederland)",
    i: "nl"
}, {
    n: "New Caledonia (Nouvelle-Calédonie)",
    i: "nc"
}, {
    n: "New Zealand",
    i: "nz"
}, {
    n: "Nicaragua",
    i: "ni"
}, {
    n: "Niger (Nijar)",
    i: "ne"
}, {
    n: "Nigeria",
    i: "ng"
}, {
    n: "Niue",
    i: "nu"
}, {
    n: "Norfolk Island",
    i: "nf"
}, {
    n: "North Korea (조선 민주주의 인민 공화국)",
    i: "kp"
}, {
    n: "Northern Mariana Islands",
    i: "mp"
}, {
    n: "Norway (Norge)",
    i: "no"
}, {
    n: "Oman (‫عُمان‬‎)",
    i: "om"
}, {
    n: "Pakistan (‫پاکستان‬‎)",
    i: "pk"
}, {
    n: "Palau",
    i: "pw"
}, {
    n: "Palestine (‫فلسطين‬‎)",
    i: "ps"
}, {
    n: "Panama (Panamá)",
    i: "pa"
}, {
    n: "Papua New Guinea",
    i: "pg"
}, {
    n: "Paraguay",
    i: "py"
}, {
    n: "Peru (Perú)",
    i: "pe"
}, {
    n: "Philippines",
    i: "ph"
}, {
    n: "Pitcairn Islands",
    i: "pn"
}, {
    n: "Poland (Polska)",
    i: "pl"
}, {
    n: "Portugal",
    i: "pt"
}, {
    n: "Puerto Rico",
    i: "pr"
}, {
    n: "Qatar (‫قطر‬‎)",
    i: "qa"
}, {
    n: "Réunion (La Réunion)",
    i: "re"
}, {
    n: "Romania (România)",
    i: "ro"
}, {
    n: "Russia (Россия)",
    i: "ru"
}, {
    n: "Rwanda",
    i: "rw"
}, {
    n: "Saint Barthélemy (Saint-Barthélemy)",
    i: "bl"
}, {
    n: "Saint Helena",
    i: "sh"
}, {
    n: "Saint Kitts and Nevis",
    i: "kn"
}, {
    n: "Saint Lucia",
    i: "lc"
}, {
    n: "Saint Martin (Saint-Martin (partie française))",
    i: "mf"
}, {
    n: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    i: "pm"
}, {
    n: "Saint Vincent and the Grenadines",
    i: "vc"
}, {
    n: "Samoa",
    i: "ws"
}, {
    n: "San Marino",
    i: "sm"
}, {
    n: "São Tomé and Príncipe (São Tomé e Príncipe)",
    i: "st"
}, {
    n: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    i: "sa"
}, {
    n: "Senegal (Sénégal)",
    i: "sn"
}, {
    n: "Serbia (Србија)",
    i: "rs"
}, {
    n: "Seychelles",
    i: "sc"
}, {
    n: "Sierra Leone",
    i: "sl"
}, {
    n: "Singapore",
    i: "sg"
}, {
    n: "Sint Maarten",
    i: "sx"
}, {
    n: "Slovakia (Slovensko)",
    i: "sk"
}, {
    n: "Slovenia (Slovenija)",
    i: "si"
}, {
    n: "Solomon Islands",
    i: "sb"
}, {
    n: "Somalia (Soomaaliya)",
    i: "so"
}, {
    n: "South Africa",
    i: "za"
}, {
    n: "South Georgia & South Sandwich Islands",
    i: "gs"
}, {
    n: "South Korea (대한민국)",
    i: "kr"
}, {
    n: "South Sudan (‫جنوب السودان‬‎)",
    i: "ss"
}, {
    n: "Spain (España)",
    i: "es"
}, {
    n: "Sri Lanka (ශ්‍රී ලංකාව)",
    i: "lk"
}, {
    n: "Sudan (‫السودان‬‎)",
    i: "sd"
}, {
    n: "Suriname",
    i: "sr"
}, {
    n: "Svalbard and Jan Mayen (Svalbard og Jan Mayen)",
    i: "sj"
}, {
    n: "Swaziland",
    i: "sz"
}, {
    n: "Sweden (Sverige)",
    i: "se"
}, {
    n: "Switzerland (Schweiz)",
    i: "ch"
}, {
    n: "Syria (‫سوريا‬‎)",
    i: "sy"
}, {
    n: "Taiwan (台灣)",
    i: "tw"
}, {
    n: "Tajikistan",
    i: "tj"
}, {
    n: "Tanzania",
    i: "tz"
}, {
    n: "Thailand (ไทย)",
    i: "th"
}, {
    n: "Timor-Leste",
    i: "tl"
}, {
    n: "Togo",
    i: "tg"
}, {
    n: "Tokelau",
    i: "tk"
}, {
    n: "Tonga",
    i: "to"
}, {
    n: "Trinidad and Tobago",
    i: "tt"
}, {
    n: "Tunisia (‫تونس‬‎)",
    i: "tn"
}, {
    n: "Turkey (Türkiye)",
    i: "tr"
}, {
    n: "Turkmenistan",
    i: "tm"
}, {
    n: "Turks and Caicos Islands",
    i: "tc"
}, {
    n: "Tuvalu",
    i: "tv"
}, {
    n: "Uganda",
    i: "ug"
}, {
    n: "Ukraine (Україна)",
    i: "ua"
}, {
    n: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    i: "ae"
}, {
    n: "United Kingdom",
    i: "gb"
}, {
    n: "United States",
    i: "us"
}, {
    n: "U.S. Minor Outlying Islands",
    i: "um"
}, {
    n: "U.S. Virgin Islands",
    i: "vi"
}, {
    n: "Uruguay",
    i: "uy"
}, {
    n: "Uzbekistan (Oʻzbekiston)",
    i: "uz"
}, {
    n: "Vanuatu",
    i: "vu"
}, {
    n: "Vatican City (Città del Vaticano)",
    i: "va"
}, {
    n: "Venezuela",
    i: "ve"
}, {
    n: "Vietnam (Việt Nam)",
    i: "vn"
}, {
    n: "Wallis and Futuna",
    i: "wf"
}, {
    n: "Western Sahara (‫الصحراء الغربية‬‎)",
    i: "eh"
}, {
    n: "Yemen (‫اليمن‬‎)",
    i: "ye"
}, {
    n: "Zambia",
    i: "zm"
}, {
    n: "Zimbabwe",
    i: "zw"
}]